<div class="hero-carousel" [class.hero-carousel--reverse]="block.data.flipped">
  <!-- Main Swiper container -->
  <div class="swiper" #swiperContainer>
    <!-- Additional required wrapper -->
    <div class="swiper-wrapper">
      <!-- Slides -->
      @for (item of block.content; track trackById(i, item); let i = $index) {
        <div class="swiper-slide hero-carousel-slide" [class.hero-carousel-slide--reverse]="block.data.flipped">
          <ng-container *ngTemplateOutlet="carouselSlideTemplate; context: { item: item }"></ng-container>
        </div>
      }
    </div>

    <!-- If we need pagination -->
    @if (block.data.options.dots) {
      <div class="swiper-pagination-home"></div>
    }

    <!-- If we need navigation buttons -->
    @if (block.content.length > 1) {
      <div class="swiper-button-hero-carousel swiper-button-hero-carousel-prev">
        <svg width="22" height="38" viewBox="0 0 22 38" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            class="swiper-button-hero-carousel-svg-path"
            d="M22.004 3.67069L18.6478 0.333313L0 19L18.6667 37.6666L22.004 34.3293L6.67475 19L22.004 3.67069Z"
            fill="#88858c" />
        </svg>
      </div>
    }
    @if (block.content.length > 1) {
      <div class="swiper-button-hero-carousel swiper-button-hero-carousel-next">
        <svg width="23" height="38" viewBox="0 0 23 38" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            class="swiper-button-hero-carousel-svg-path"
            d="M0.666748 34.3293L4.02298 37.6666L22.6708 19L4.00412 0.333313L0.666748 3.67069L15.996 19L0.666748 34.3293Z"
            fill="#88858c" />
        </svg>
      </div>
    }
  </div>
</div>

<ng-template #carouselSlideTemplate let-item="item">
  <!-- Content -->
  <div class="hero-carousel-slide__panel hero-carousel-slide__panel--content">
    @if (item.data.heading) {
      <h2 class="hero-carousel-slide__panel-heading" [innerHTML]="item.data.heading"></h2>
    }
    @if (item.data.content) {
      <div class="hero-carousel-slide__panel-description" [innerHTML]="item.data.content"></div>
    }

    <core-coro-button [button]="item.data.button"></core-coro-button>
  </div>

  <!-- Image -->
  <div class="hero-carousel-slide__panel hero-carousel-slide__panel--media">
    <img [src]="getSlideImgUrl(item.data.image)" [alt]="item.data.altText" />
  </div>
</ng-template>
